export const DISTANCE = {
  MILLIMETERS: 'mm',
  CENTIMETERS: 'cm',
  INCHES: 'in',
  FRACTIONAL_INCHES: 'fin'
};

export const FRACTIONAL_INCHES_DENOMINATOR = 16;

export const AREA = {
  SQUARE_MILLIMETERS: 'mm2',
  SQUARE_CENTIMETERS: 'cm2',
  SQUARE_INCHES: 'in2'
};

export const STRENGTH = {
  NEWTON_SQUARE_MILLIMETERS: 'N/mm2',
  POUND_PER_SQUARE_INCH: 'psi'
};

export const LOAD = {
  NEWTON: 'N',
  DECANEWTON: 'daN',
  KILONEWTON: 'kN',
  POUND_FORCE: 'lbf'
};

export const MOMENT = {
  NEWTON_METERS: 'Nm',
  DECANEWTON_METER: 'daNm',
  KILONEWTON_METER: 'kNm',
  FOOT_POUND_FORCE: 'lbf ft'
};

export const TEMPERATURE = {
  CELSIUS: 'C',
  FAHRENHEIT: 'F'
};

export const WEIGHT = {
  KILOGRAM: 'kg',
  GRAM: 'g',
  POUND: 'lb'
};



// WEBPACK FOOTER //
// ./src/reducers/units.js